import React from 'react';
import { Slice } from 'gatsby';

const Footer = () => (
    <footer>
        <Slice alias="footer-navigation" />
        <Slice alias="bottom-footer-navigation" />
    </footer>
);

export default Footer;
